import React, { useState } from 'react';
import { MdOutlineCheckCircle } from 'react-icons/md';
import useTranslate from '@src/i18n/useTranslate';
import { Message } from './styles';
import Button from '@src/components/ui2/Button';
import ResponsiveModal from '@src/components/ui2/ResponsiveModal';
import PhoneVerification from '@src/components/reusable/PhoneVerification';
import usePhoneVerification from '@src/hooks/usePhoneVerification';

export const PhoneVerificationSection = () => {
  const { i18n } = useTranslate();

  const { loading, isOver } = usePhoneVerification();

  const [verificationModalOpen, setVerificationModalOpen] = useState(false);

  return (
    <>
      <Message>{i18n('direct_link_validate_phone_message')}</Message>

      <Button onClick={() => setVerificationModalOpen(true)} fullWidth>
        {i18n('direct_link_validate_phone_validate')}
        <MdOutlineCheckCircle />
      </Button>

      <ResponsiveModal
        open={verificationModalOpen}
        onClose={() => setVerificationModalOpen(false)}
        title={i18n('direct_link_validate_phone_modal_title')}
        width={400}
      >
        <PhoneVerification.Form
          onSuccess={() => setVerificationModalOpen(false)}
          render={({ form }) => (
            <>
              <PhoneVerification.Description />

              <PhoneVerification.Input form={form} />

              <PhoneVerification.Message />

              {!loading && isOver ? (
                <div style={{ margin: '16px 0px' }}>
                  <PhoneVerification.ResendCode />
                </div>
              ) : null}

              <PhoneVerification.SubmitButton fullWidth={false}>
                {i18n('direct_link_phone_verification_form_submit')}
              </PhoneVerification.SubmitButton>
            </>
          )}
        />
      </ResponsiveModal>
    </>
  );
};

export default PhoneVerificationSection;
